if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        
        // this.onRadioClick = this.onRadioClick.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        this.onPerksClick = this.onPerksClick.bind(this);
        
        const radio = this.querySelector('input[type="radio"]');
        // const button = this.querySelector('input[type="button"]');
        this.productHandle = radio.dataset.handle;
        this.autoApplyDiscount = radio.dataset.autoApplyDiscount;
        this.specialDiscountCode = radio.dataset.specialDiscountCode;
        this.evergreenOffersVisibility  = radio.dataset.evergreenOffersVisibility;
        this.isBuybox = radio.dataset.isBuybox;

        console.log("autoApplyDiscount: ", this.autoApplyDiscount)
        console.log("evergreenOffersVisibility: ", this.evergreenOffersVisibility)
        console.log("specialDiscountCode: ", this.specialDiscountCode)
        
        this.radioButton = radio;
        // button.addEventListener('click', this.onBodyClick);
        this.selectedCode = '';
        this.wrapperDiv = this.querySelector('div.subscription-box');
        
        this.wrapperDiv.addEventListener('click', this.onBodyClick);
        this.allWrapperDivs = document.querySelectorAll('div.subscription-box');
        this.variantInput = document.querySelector('input[type="hidden"].product-variant-id');
        this.productInput = document.querySelector('input[type="hidden"][name="product-id"]');
        this.form = document.querySelector('form.form[action="/cart/add"]');
        this.productTitle = document.querySelector('.product__title h1');
        this.cartTextSpan = this.form.querySelector('button[type="submit"][name="add"] span');
        this.pricePerDay = document.querySelector('.pdp-price-per-day-wrapper p');
        this.buyboxMainPrice = document.querySelector('.price--buybox');
        this.buyboxDisclaimer = document.querySelector('.disclaimer-buybox');
        this.deliveryChargeFrequency = document.querySelector('.delivery-charge--frequency');
        if (this.radioButton.dataset.checked && window.getComputedStyle(this).display !== 'none') {
          if (!this.form.querySelector('input[type="hidden"][name="selling_plan"]')) {
            const input = document.createElement('input');
            input.type='hidden';
            input.name='selling_plan';
            this.form.appendChild(input);
          }
          this.radioButton.checked = true;

          // Checking because these elements are not present in all module variations
          if (this.cartTextSpan !== null) {
            this.cartTextSpan.innerText = "ADD TO CART - " + this.radioButton.dataset.price;
          }
          if (this.buyboxMainPrice !== null) {
            this.buyboxMainPrice.innerHTML = this.radioButton.dataset.monthlyPrice;
          }
          if (this.buyboxDisclaimer !== null) {
            this.buyboxDisclaimer.innerHTML = this.radioButton.dataset.disclaimer;
          }
          if (this.deliveryChargeFrequency !== null) {
            this.deliveryChargeFrequency.innerHTML = this.radioButton.dataset.deliveryChargeFrequency;
          }
          
          this.variantInput.value = this.radioButton.dataset.variantId;
          this.productInput.value = this.radioButton.dataset.productId;
          this.form.querySelector('input[type="hidden"][name="selling_plan"]').value = this.radioButton.dataset.sellingPlanId;
          this.form.querySelector('input[type="hidden"][name="selling_plan"]').id = 'selling_plan_id';

        } else {
          var self = this;
          setTimeout(function() {
            self.radioButton.checked = false;
          }, 100);
        }

        this.perksDiv = this.querySelector('div.subscription-perks');
        if (this.perksDiv) {
          this.perksDiv.addEventListener('click', this.onPerksClick);
        }

        this.handle = this.handle.bind(this);
        document.addEventListener('', this.handle);

        this.normalSubOption = this.querySelector('.subscription-box__title.normal');
        this.discountSubOption = this.querySelector('.subscription-box__title.discounted');
        this.subDiscountCode = [
          'annual-199-subscription-new', 
          'annual-subscription-new', 
          '12-month-plan', 
          'minimalist-digital-silk-sonder-membership-12-month', 
          'digital-only-silk-sonder-membership-annual'
        ].includes(this.radioButton.dataset.handle) ? 'FREEMONTH' : 'FIVEOFF';

        // Calling this because buybox doesn't have available offers that calls it for the normal pdp
        if(this.autoApplyDiscount && this.isBuybox) {
          document.dispatchEvent(new CustomEvent('', {
            detail: { code: this.subDiscountCode }
          }));
        }

        // Add special discount code if present
        if(this.specialDiscountCode && this.specialDiscountCode !== '') {
          document.dispatchEvent(new CustomEvent('', {
            detail: { code: this.specialDiscountCode }
          }));
        }
      }

      handleClick() {
        console.log("=== HANDLE CLICK START ===");
        // Set the selling plan value
          const sellingPlanInput = this.form.querySelector('input[type="hidden"][name="selling_plan"]');
          sellingPlanInput.value = this.radioButton.dataset.sellingPlanId;
          this.form.querySelector('input[type="hidden"][name="selling_plan"]').value = sellingPlanInput.value;
          const element = this.form.querySelector('input[id="selling_plan_id"]');
          element.value = sellingPlanInput.value;
        if (!this.form.querySelector('input[type="hidden"][name="selling_plan"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          this.form.appendChild(input);
        }
        
        if (!this.radioButton.checked) {
          this.radioButton.checked = true;
          this.allWrapperDivs.forEach(div => div.classList.remove('active'));
          this.wrapperDiv.classList.add('active');
          
          this.variantInput.value = this.radioButton.dataset.variantId;
          this.productInput.value = this.radioButton.dataset.productId;
          this.form.querySelector('input[type="hidden"][name="selling_plan"]').value= this.radioButton.dataset.sellingPlanId;  
          const availableCode = pdpDiscountEnabled() ?  
            ['annual-199-subscription-new', 
              'annual-subscription-new', 
              '12-month-plan', 
              'minimalist-digital-silk-sonder-membership-12-month', 
              'digital-only-silk-sonder-membership-annual'
            ].includes(this.radioButton.dataset.handle) ? 
            'FREEMONTH' : 'FIVEOFF' : '';

          document.dispatchEvent(new CustomEvent('availableDiscountCodeChanged', {
            detail: { code: availableCode }
          }));

          console.log("availableCode:", availableCode);
          
          document.dispatchEvent(new CustomEvent('', {
            detail: { 
              code: this.specialDiscountCode && this.specialDiscountCode !== '' ? this.specialDiscountCode : (this.autoApplyDiscount == "true" && this.evergreenOffersVisibility == 'show') ? availableCode : '' 
            }
          }));
          
          this.renderSubscriptionText();
          this.renderATCButton();
          this.renderPricePerDay();
          this.renderPriceAndTodaysTotal();
        }
      }

      onBodyClick() {
        console.log("ON BODY CLICK CALLED")
        this.handleClick();
      }

      onPerksClick() {
        console.log("ON PERKS CLICK CALLED")
        this.perksDiv.classList.toggle('active');
      }

      handle(ev) {
        console.log("ON HANDLE DISCOUNT CODE SELECTED CALLED")
        this.selectedCode = ev.detail.code;
        this.renderSubscriptionText();
        this.renderATCButton();
        this.renderPricePerDay();
        this.renderPriceAndTodaysTotal();
      }

      renderSubscriptionText() {
        console.log("RENDER SUBS TEXT CALLED")
        if (!this.normalSubOption || !this.discountSubOption) {
          return;
        }
        this.normalSubOption.classList.remove('hidden');
        this.discountSubOption.classList.add('hidden');
        if (!this.radioButton.checked) {
          return;
        }
        if (this.subDiscountCode === this.selectedCode) {
          this.normalSubOption.classList.add('hidden');
          this.discountSubOption.classList.remove('hidden');
        }

      }
      renderATCButton() {
        console.log("RENDER ATC BUTTON CALLED")
        if (!this.radioButton.checked) {
          return;
        }

        if (!this.selectedCode || !['FIVEOFF', 'FREEMONTH'].includes(this.selectedCode)) {
          if (this.cartTextSpan !== null) {
            this.cartTextSpan.innerText = "ADD TO CART - " + this.radioButton.dataset.price; 
          }
        } else {
          const originPrice = parseInt(this.radioButton.dataset.priceValue);
          let discountPrice = originPrice * (100 - 5.0) / 100;
          if (this.selectedCode === 'FREEMONTH') {
            discountPrice = originPrice - 1995;
          }
          if (this.cartTextSpan !== null) {
            this.cartTextSpan.innerHTML = `ADD TO CART - <strike>${this.radioButton.dataset.price}</strike>&nbsp;$${(Math.round(discountPrice)/100.0).toFixed(2)}`;  
          }
        }
      }
      renderPriceAndTodaysTotal() {
        console.log("RENDER PRICE AND TODAYS TOTAL CALLED")
        if (!this.radioButton.checked) {
          return;
        }

        if (this.deliveryChargeFrequency !== null) {
          this.deliveryChargeFrequency.innerHTML = this.radioButton.dataset.deliveryChargeFrequency;
        }
        if (this.buyboxMainPrice !== null) {
          this.buyboxMainPrice.innerHTML = this.radioButton.dataset.monthlyPrice;
        }
        if (this.buyboxDisclaimer !== null) {
          this.buyboxDisclaimer.innerHTML = this.radioButton.dataset.disclaimer;
        }
      }
      renderPricePerDay() {
        if (!this.radioButton.checked || !this.pricePerDay) {
          return;
        }

        this.pricePerDay.innerText = `Just $${this.radioButton.dataset.perDayPrice}/day`;
      }
    }
  );
}
